<ng-container *transloco="let translate">
  <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center center">
    <eg-icon-button
      egBorderStyle="hidden"
      egButtonSize="small"
      icon="/assets/icons/copy.svg"
      (click)="toggleDropdown()"
      [disabled]="showAddGoodsForm"
    ></eg-icon-button>

    <div class="copy-function-dropdown" [ngClass]="{ show: dropdownOpen }">
      <div fxLayout="column">
        <form [formGroup]="formGroup" class="form" fxFlex="100" fxLayout="column">
          <div fxFlex class="p-5">
            <eg-number-selection
              fxFlex="100"
              [label]="translate(prefix + '.copyAmount')"
              value="0"
              [max]="allowedMax"
              formControlName="copies"
              [ngClass]="{ 'red-border': showError }"
            ></eg-number-selection>
          </div>
        </form>
      </div>

      <div fxLayoutAlign="end center" fxLayout="row wrap" fxLayoutGap="5px" class="eg-modal-footer">
        <button (click)="onCancel(r)" egButton egType="round" egButtonSize="small" egStyle="secondary">
          {{ translate('support.button.cancel') }}
        </button>
        <button (click)="onSave()" egButton egType="round" egButtonSize="small" egStyle="primary">
          {{ translate('support.button.copy') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
